import { useState, useEffect } from "react";
import { AlertTriangle } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Global banner that appears when the platform is in maintenance mode.
 * Polls /api/maintenance/status every 20s. Mount once in the root layout.
 */
export function MaintenanceBanner() {
  const [state, setState] = useState({ enabled: false, message: "" });

  useEffect(() => {
    let cancelled = false;
    const poll = async () => {
      try {
        const res = await fetch(`${API}/maintenance/status`);
        if (!res.ok) return;
        const data = await res.json();
        if (!cancelled) setState(data);
      } catch {
        /* ignore */
      }
    };
    poll();
    const iv = setInterval(poll, 20000);
    return () => { cancelled = true; clearInterval(iv); };
  }, []);

  if (!state.enabled) return null;

  return (
    <div
      className="sticky top-0 z-50 bg-red-600 text-white px-4 py-2 text-sm flex items-center gap-2 shadow-md"
      data-testid="maintenance-banner"
    >
      <AlertTriangle className="w-4 h-4 flex-shrink-0" />
      <span className="flex-1 min-w-0 truncate">
        <strong>Underhållsläge:</strong>{" "}
        {state.message || "Plattformen är under underhåll. Försök igen om några minuter."}
      </span>
    </div>
  );
}
